import Vue from 'vue';
import store from 'client/store';
import config from 'client/config';
import socket from 'client/socket';
import router from "@/app/router";

// Send a request to the login URL and save the returned JWT
function login(creds, dest) {
  return new Promise((resolve, reject) => {
    Vue.http.post(config.root + '/seUsers/sce-login', creds).then(result => {
      setToken(result.body, dest).then(result => resolve(result), err => reject(err))
    }, err => reject(err))
  })
}

function setToken(token, dest = null) {
  return new Promise((resolve, reject) => {
    localStorage.setItem('id_token', token.id)
    localStorage.setItem('id_user', token.userId)
    checkToken().then(result => {
      if (dest) {
        let route = { path: dest }
        if (dest === 'homepage') {
          route = store.state.user.homepage
        }
        router.push(route)
      }
      resolve(result)
    }, err => reject(err))
  })
}

// To log out, we just need to remove the token
function logout() {
  localStorage.removeItem('id_token');
  localStorage.removeItem('id_user');
  store.dispatch("user.logout");
  socket.disconnect();
}

/**
 * checks if a token is present and uses the token to authenticate the user and load the user context informaion
 * the promise resolves when the user context is successfully loaded in the store.
 * Rejection means either there is no token or the token is invalid.
 *
 * @returns {Promise<unknown>}
 */
function checkToken() {
  return new Promise(function (resolve, reject) {
    const token = localStorage.getItem('id_token')
    const userId = localStorage.getItem('id_user')
    if (token !== null) {
      Vue.http.headers.common['Authorization'] = token;
      socket.emit('authentication', {token, userId})
      socket.emit('setUserId', userId)
      store.dispatch('user.set', {id: userId}).then(() => {
        resolve()
      }).catch(function (err) {
        reject(err)
      })
    } else {
      reject("no user in local store")
    }
  })
}

/**
 * Check if the user has access right by specifying the context and permitted roles
 *
 * TODO: merge this function with checkContextRole in user.js
 *
 * @param context
 * @param roles
 * @returns {*}
 */
function checkAccess(context, roles) {
  const userRoles = store.state.user.roles
  return roles.includes(userRoles[context])
}

export default {
  login,
  setToken,
  logout,
  checkToken,
  checkAccess,
}
